import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const CompletedEnrollmentIllustration = (props: SVGProps) => {
  const {
    title = 'CompletedEnrollmentIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 302 203"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <path
        d="M209.601 174.533C209.758 164.333 187.167 155.717 159.143 155.288C131.118 154.859 108.272 162.779 108.115 172.979C107.958 183.179 130.549 191.795 158.573 192.224C186.598 192.653 209.444 184.732 209.601 174.533Z"
        fill="currentColor"
      />
      <path
        d="M108.113 171.835C107.96 182.038 130.798 190.657 158.817 191.08C186.837 191.502 209.684 183.585 209.846 173.383L210.126 155.335L108.637 154.202L108.113 171.835Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <mask
        id="mask0_7075_519"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="106"
        y="154"
        width="106"
        height="39"
      >
        <path
          d="M106.858 172.47C106.705 182.673 130.527 192.218 158.555 192.641C186.584 193.073 210.911 185.084 211.065 174.882L210.379 156.888L107.382 154.828L106.858 172.461V172.47Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_7075_519)">
        <path
          d="M112.861 160.248V182.875"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M122.069 164.648V187.284"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M131.268 169.562V192.189"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M140.476 171.859V194.486"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M149.683 171.859V194.486"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M158.891 173.027V195.663"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M168.098 171.859V194.486"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M177.305 171.564V194.191"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M186.512 169.562V192.189"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M195.719 165.969V188.596"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
        <path
          d="M204.151 160.248V189.496"
          stroke="#161718"
          strokeWidth="3.77214"
          strokeMiterlimit="10"
        />
      </g>
      <path
        d="M210.127 155.343C210.284 145.143 187.693 136.527 159.668 136.098C131.643 135.669 108.797 143.59 108.64 153.79C108.483 163.989 131.074 172.606 159.099 173.035C187.123 173.464 209.969 165.543 210.127 155.343Z"
        fill="#161718"
        stroke="white"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M201.373 154.329C201.391 147.795 182.605 142.446 159.413 142.381C136.221 142.317 117.405 147.561 117.387 154.095C117.368 160.629 136.154 165.978 159.346 166.043C182.539 166.107 201.354 160.863 201.373 154.329Z"
        fill="#161718"
        stroke="currentColor"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M209.596 138.193C209.753 127.993 187.162 119.377 159.138 118.948C131.113 118.519 108.267 126.439 108.11 136.639C107.953 146.839 130.544 155.455 158.568 155.884C186.593 156.313 209.439 148.393 209.596 138.193Z"
        fill="currentColor"
      />
      <path
        d="M106.858 154.871C106.705 165.074 130.527 174.619 158.555 175.042C186.584 175.474 211.363 167.134 211.525 156.932L211.065 138.614L106.858 133.396V154.862V154.871Z"
        fill="white"
      />
      <path
        d="M108.113 135.496C107.96 145.698 130.798 154.317 158.817 154.74C186.837 155.163 209.684 147.246 209.846 137.043L210.126 118.996L108.637 117.862L108.113 135.496Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M207.581 142.989C207.581 142.989 194.221 155.324 164.369 154.739"
        stroke="#161718"
        strokeWidth="4.40083"
        strokeMiterlimit="10"
      />
      <path
        d="M210.13 119.005C210.288 108.805 187.697 100.189 159.672 99.7597C131.647 99.3307 108.801 107.251 108.644 117.451C108.487 127.651 131.078 136.267 159.103 136.696C187.127 137.125 209.973 129.205 210.13 119.005Z"
        fill="#161718"
        stroke="white"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M201.374 117.982C201.392 111.448 182.606 106.099 159.414 106.034C136.222 105.969 117.406 111.214 117.388 117.748C117.369 124.282 136.155 129.631 159.347 129.695C182.539 129.76 201.355 124.516 201.374 117.982Z"
        fill="#161718"
        stroke="currentColor"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M157.409 118.77C182.72 118.77 203.238 98.3194 203.238 73.0928C203.238 47.8662 182.72 27.416 157.409 27.416C132.098 27.416 111.579 47.8662 111.579 73.0928C111.579 98.3194 132.098 118.77 157.409 118.77Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.55839"
        strokeMiterlimit="10"
      />
      <path
        d="M163.15 118.77C188.461 118.77 208.979 98.3194 208.979 73.0928C208.979 47.8662 188.461 27.416 163.15 27.416C137.839 27.416 117.32 47.8662 117.32 73.0928C117.32 98.3194 137.839 118.77 163.15 118.77Z"
        fill="white"
      />
      <path
        d="M163.149 107.11C181.999 107.11 197.28 91.8796 197.28 73.0926C197.28 54.3056 181.999 39.0757 163.149 39.0757C144.299 39.0757 129.019 54.3056 129.019 73.0926C129.019 91.8796 144.299 107.11 163.149 107.11Z"
        stroke="#161718"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M148.339 72.7472L160.989 84.839L183.876 61.8921"
        stroke="currentColor"
        strokeWidth="4.2"
        strokeMiterlimit="10"
      />
      <path
        d="M207.219 16.4192C216.318 16.4192 223.693 9.06878 223.693 0C223.693 9.06878 231.068 16.4192 240.167 16.4192C231.068 16.4192 223.693 23.7696 223.693 32.8383C223.693 23.7696 216.318 16.4192 207.219 16.4192Z"
        fill="white"
      />
      <path
        d="M207.219 16.4192C216.318 16.4192 223.693 9.06878 223.693 0C223.693 9.06878 231.068 16.4192 240.167 16.4192C231.068 16.4192 223.693 23.7696 223.693 32.8383C223.693 23.7696 216.318 16.4192 207.219 16.4192Z"
        stroke="white"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M247.533 49.2635C254.403 49.2635 259.061 43.7665 259.061 36.9829C259.061 43.7665 264.621 49.2635 271.491 49.2635C264.621 49.2635 259.061 54.7606 259.061 61.5442C259.061 54.7606 254.403 49.2635 247.533 49.2635Z"
        stroke="white"
        strokeWidth="3.77214"
        strokeMiterlimit="10"
      />
      <path
        d="M52.8115 61.8536L52.8115 142.275H66.4892V61.8536H52.8115Z"
        stroke="white"
        strokeWidth="3.77"
        strokeMiterlimit="10"
      />
      <path
        d="M52.8223 44.3585V62.0933H66.5V44.3585H52.8223Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.77"
        strokeMiterlimit="10"
      />
      <path
        d="M27.3535 114.739V142.275H41.0312V114.739H27.3535Z"
        stroke="white"
        strokeWidth="3.77"
        strokeMiterlimit="10"
      />
      <path
        d="M27.3535 72.3986L27.3535 114.998H41.0312V72.3986H27.3535Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.77"
        strokeMiterlimit="10"
      />
      <path
        d="M1.88477 127.077L1.88477 142.282H15.5625L15.5625 127.077H1.88477Z"
        stroke="white"
        strokeWidth="3.77"
        strokeMiterlimit="10"
      />
      <path
        d="M1.88477 102.901L1.88477 127.316H15.5625L15.5625 102.901H1.88477Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="3.77"
        strokeMiterlimit="10"
      />
      <path
        d="M295.996 101.816L248.628 152.011"
        stroke="currentColor"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
      <path
        d="M270.749 101.816H295.997V126.98"
        stroke="currentColor"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
      <path
        d="M295.996 150.717L267.095 181.342"
        stroke="currentColor"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
      <path
        d="M270.749 150.717H295.997V175.881"
        stroke="currentColor"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

CompletedEnrollmentIllustration.displayName = 'CompletedEnrollmentIllustration';
